import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditQualification = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        certificate_number: '',
        date_issue: '',
        organization_name: '',
        OGRN: '',
        file_id: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-qualification?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.certificate_number) {
            newErrors.certificate_number = 'Обязательное поле';
        }
        if (formInfo.certificate_number && (formInfo.certificate_number.length < 2 || formInfo.certificate_number.length > 50)) {
            newErrors.university_name = 'Значение не может быть меньше 2 и более 50 символов';
        }

        if (!formInfo.date_issue) {
            newErrors.date_issue = 'Обязательное поле';
        }

        if (!formInfo.organization_name) {
            newErrors.organization_name = 'Обязательное поле';
        }
        if (formInfo.organization_name && (formInfo.organization_name.length < 2 || formInfo.organization_name.length > 200)) {
            newErrors.organization_name = 'Значение не может быть меньше 2 и более 200 символов';
        }
        if (!formInfo.OGRN) {
            newErrors.OGRN = 'Обязательное поле';
        }

        if (action=='add' && !files.certificate) {
            newErrors.certificate = 'Прикрепите файл';
        }

    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('certificate_number', formInfo.certificate_number);
        formData.append('date_issue', normalizeDate(formInfo.date_issue));
        formData.append('organization_name', formInfo.organization_name);
        formData.append('OGRN', formInfo.OGRN);

        if (files.certificate) {
            formData.append('file_certificate', files.certificate);
        }

        axios.put('/api/add-new-qualification', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            openTimeModal('Данные успешно сохранены', 'success');
            setFiles({
                certificate: null,
            });
            onSuccess();
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`}</a>);
        })
    }

    const changeData = () => {
        axios.put(`/api/change-qualification`, {
            id: formInfo.id,
            user_id: userId,
            certificate_number: formInfo.certificate_number,
            date_issue: normalizeDate(formInfo.date_issue),
            organization_name: formInfo.organization_name,
            OGRN: formInfo.OGRN,
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        certificate: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;сведений о повышении квалификации
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер свидетельства</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.certificate_number} 
                                onChange={handleChange('certificate_number')} 
                                className={errorsForm.certificate_number ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='50' 
                                disabled={loading}
                                required />
                                {errorsForm.certificate_number && <div className='errorUnderInput'>{errorsForm.certificate_number}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата выдачи</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_issue?.split('T')[0]}
                                onChange={handleChange('date_issue')} 
                                className={errorsForm.date_issue ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_issue && <div className='errorUnderInput'>{errorsForm.date_issue}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Наименование организации</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.organization_name} 
                                onChange={handleChange('organization_name')} 
                                className={errorsForm.organization_name ? 'inputError' : ''}
                                placeholder='Полное название без сокращений' 
                                minLength='' 
                                maxLength='200' 
                                disabled={loading}
                                required />
                                {errorsForm.organization_name && <div className='errorUnderInput'>{errorsForm.organization_name}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>ОГРН</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.OGRN} 
                                onChange={handleChange('OGRN')} 
                                className={errorsForm.OGRN ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='15' 
                                disabled={loading}
                                required />
                                {errorsForm.OGRN && <div className='errorUnderInput'>{errorsForm.OGRN}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Файл</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить файл'
                                        file={files.certificate}
                                        buttonLabel='Прикрепить файл'
                                        onChange={handleFileChange('certificate')}
                                        onReset={handleFileReset('certificate')}
                                    />
                                    {errorsForm.certificate && <div className='errorUnderInput'>{errorsForm.certificate}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditQualification;